import { useEffect } from 'react';
import { useViewTemplates } from './useViewTemplates';

export function useAllViewTemplates(
  workflowTemplateId?: string | null,
  type?: MBAPI.ViewType,
  subtype?: MBAPI.ViewSubtype,
  name?: string,
  isPublic?: boolean,
  skip?: boolean,
): {
  viewTemplates: MBAPI.ViewTemplate[];
  loading: boolean;
  error?: Error;
} {
  const { viewTemplates, hasMore, fetchMore, loading, moreLoading, error } = useViewTemplates({
    workflowTemplateId,
    type,
    subtype,
    name,
    isPublic,
    skip,
  });

  useEffect(() => {
    if (hasMore && !moreLoading && viewTemplates.length > 0) {
      fetchMore();
    }
  }, [fetchMore, hasMore, moreLoading, viewTemplates.length]);

  return {
    viewTemplates,
    loading: loading || moreLoading,
    error,
  };
}
